export default __webpack_public_path__ + "static/media/empty.ea0de76b.png";